export function is_watershed_minimum(obj) {
    return obj.watershed_id !== undefined;
}
